import { useState, useEffect } from 'react';

export const useImagePreloader = (imageUrls) => {
    const [loadedImages, setLoadedImages] = useState(new Set());
    const [isLoading, setIsLoading] = useState(true);
    const [loadingProgress, setLoadingProgress] = useState(0);

    useEffect(() => {
        if (!imageUrls || imageUrls.length === 0) {
            setIsLoading(false);
            return;
        }

        let loadedCount = 0;
        const totalImages = imageUrls.length;

        const preloadImage = (url) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    loadedCount++;
                    setLoadedImages(prev => new Set([...prev, url]));
                    setLoadingProgress((loadedCount / totalImages) * 100);
                    
                    if (loadedCount === totalImages) {
                        setIsLoading(false);
                    }
                    resolve(url);
                };
                img.onerror = () => {
                    loadedCount++;
                    setLoadingProgress((loadedCount / totalImages) * 100);
                    
                    if (loadedCount === totalImages) {
                        setIsLoading(false);
                    }
                    reject(new Error(`Failed to load image: ${url}`));
                };
                img.src = url;
            });
        };

        // Предзагружаем все изображения
        Promise.allSettled(imageUrls.map(preloadImage))
            .then(() => {
                setIsLoading(false);
            })
            .catch(() => {
                setIsLoading(false);
            });

    }, [imageUrls]);

    return {
        isLoading,
        loadingProgress,
        loadedImages,
        isImageLoaded: (url) => loadedImages.has(url)
    };
};
